export default __webpack_public_path__ + "static/entertainment-video-interscroller-646f7ee90a6e4072c48f44cdd190fb37.gif";